import { InputControlMask } from './InputControlMask';

const Input = ({
    id,
    field,
    label = '',
    type = 'text',
    placeholder = '',
    value,
    isRequired = true,
    isReadOnly,
    onChange,
    mask,
    pattern,
    title,
    onlyInput = false,
    cssClassStyle = '',
    onBlur = undefined,
    ariainvalid = false,
    error = false,
}: IPropsInput) => {

    const cssInput = `input-field-re-ni ${cssClassStyle}`;

    const GetType = (typeInput: string) => {
        switch (typeInput) {
            case 'text':
                return <input
                    id={id}
                    name={field}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    onChange={onChange}
                    readOnly={isReadOnly}
                    className={ !error ? cssInput : `${cssInput} invalid-input `}
                    autoComplete='off'
                    title={title}
                    onBlur={onBlur}
                     aria-invalid={!!ariainvalid}                    
                />;
            case 'textarea':
                return <textarea
                    name={field}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    onChange={onChange}
                    readOnly={isReadOnly}
                    className={`${cssInput} input-field-area-re-ni`}
                    autoComplete='off'
                    wrap='hard'
                />

            case 'email':
                return <input
                    id={id}
                    name={field}
                    onChange={onChange}
                    //className={cssClassInput}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    className={cssInput}

                />;

            case 'number':
                return <input
                    id={id}
                    name={field}
                    onChange={onChange}
                    className={cssInput}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    min={0}
                    autoComplete='off'
                    readOnly={isReadOnly}
                    title='Campo requerido'
                />
            case 'mask':
                return <InputControlMask
                    name={field}
                    onChange={onChange}
                    className={cssInput}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    mask={mask}
                    required={isRequired}
                    pattern={pattern}
                    title={title}
                    autoComplete='off'
                />;
        }

    }


    return (
        <>
            {!onlyInput && <div className="lbl-input-re-ni mt-10 mb-5">
                <span> {label} </span>
            </div>}
            <div className="mb-10">
                {GetType(type)} 
                {error && <span className="lbl-input-re-ni error-message">{title}</span>} {/* Mensaje visual adicional */}
            </div>
        </>
    );
};

export { Input };